let  bankCodeOptions = [
  {'上海浦东发展银行':'0310'},
  {'中信银行':'0302'},
  {'中国光大银行':'0303'},
  {'中国农业银行':'0103'},
  {'中国工商银行':'0102'},
  {'中国建设银行':'0105'},
  {'中国邮政储蓄银行':'0403'},
  {'中国银行':'0104'},
  {'兴业银行':'0309'},
  {'华夏银行':'0304'},
  {'招商银行':'0308'},
  {'平安银行':'0307'},
  {'广发银行':''},
  {'无锡农村商业银行':''},
  {'江苏江阴农村商业银行':''},
  {'江苏银行':'05083000'},
  {'交通银行':'0301'},
]

export default bankCodeOptions



// WEBPACK FOOTER //
// ./src/utils/bankCodeOptions.js